<template>
    <div>
        <div class="topbar">
            <div class="topbar-left">
                <div class="text-center version">
                    <router-link :to="{ name: 'dashboard.index' }" class="logo">
                        <i class="icon-magnet icon-c-logo"></i>
                        <img src="/static/images/logo_pumpmylead_white.png" alt="Logo Pump My Lead" class="img-responsive logo_pump">
                    </router-link>
                    <!-- <small>v1.0.4</small> -->
                </div>
            </div>
            <div class="navbar navbar-default" role="navigation">
                <div class="container p-0">
                    <div class="pull-left">
                        <button class="button-menu-mobile open-left" @click="toggleMenu()">
                            <i class="ion-navicon"></i>
                        </button>
                        <span class="clearfix"></span>
                    </div>
                    <form class="navbar-left app-search pull-left" @submit.prevent="globalSearch()" data-step="7">
                        <div class="select_search search_header">
                            <vue-multiselect
                                v-model="search"
                                :id="`select_${_uid}`"
                                :options="dealOptions"
                                :allow-empty="false"
                                :placeholder="$t('search_deal') + `...`"
                                :custom-label="customLabel"
                                :block-keys="['Tab']"
                                selectLabel=""
                                selectedLabel=""
                                deselectLabel=""
                                label="email"
                                track-by="id"
                                :searchable="true"
                                :loading="isSearching"
                                :internal-search="false"
                                :clear-on-select="true"
                                :close-on-select="true"
                                :options-limit="300"
                                :limit="8"
                                :show-labels="true"
                                @search-change="asyncFind"
                            >
                                <template slot="option" slot-scope="props">
                                    <div class="clearfix d_flex">
                                        <div class="min_w_50">
                                            <img class="img-circle thumb-40" :src="props.option.lead.avatar || `/static/images/avatar.jpg`">
                                        </div>
                                        <div>
                                            <div class="d_flex p-0">
                                                <p class="option__title t_overflow bold m-0">#{{ props.option.code }} - <span v-if="props.option.lead.full_name">{{ props.option.lead.full_name }}</span></p>
                                                <span v-if="props.option.status !== 'open'" class="status_deal status_header" :class="{ 'sold': props.option.status === 'sold', 'lost': props.option.status === 'lost' }">{{ $t(props.option.status) }}</span>
                                            </div>
                                            <small class="option__small t_overflow show" v-if="props.option.lead.email">({{ props.option.lead.email }})</small>
                                        </div>
                                    </div>
                                </template>
                                <p slot="noResult" class="p-10 m-0 t_center"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</p>
                            </vue-multiselect>
                            <button type="submit" class="custom_search_btn"><i class="fa fa-search"></i></button>
                        </div>
                    </form>
                    <ul class="nav navbar-nav navbar-right pull-right menu_top">
                        <li class="search_icon_mobile">
                            <a href="#" @click.prevent="toggleSearch()">
                                <i class="fa fa-search"></i>
                                <i class="fa fa-times"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#" @click.prevent="tour()" v-if="showTourBtn">
                                <i class="fa fa-plane m-r-5"></i> <span class="hide_mobile">{{ $t('start_tour') }}</span>
                            </a>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                                <img :src="`/static/images/flags/${flag}.png`" :alt="language" class="flag_select">
                            </a>
                            <ul class="dropdown-menu flag_lang">
                                <li><a href="#" @click.prevent="switchLanguage('pt-BR')"><img src="/static/images/flags/bra.png" alt="Português"> Português</a></li>
                                <li><a href="#" @click.prevent="switchLanguage('en-US')"><img src="/static/images/flags/usa.png" alt="English"> English</a></li>
                            </ul>
                        </li>
                        <PmlNotifications></PmlNotifications>
                        <li class="hidden-xs">
                            <a href="#" @click.prevent="showSidebar = !showSidebar" class="right-bar-toggle pmlFormatCurrencyByIdwaves-light"><i class="md-headset-mic"></i></a>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                                <span class="initial_name">{{ member.name_initials }}</span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="member.is_admin">
                                    <router-link :to="{ name: 'company.index' }" data-step="1"><i class="fa-fw ti-briefcase m-r-5"></i> {{ $t('company') }}</router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'profile.index' }" data-step="2"><i class="fa-fw ti-user m-r-5"></i> {{ $t('profile') }}</router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'integrations.index' }" data-step="3"><i class="fa-fw ti-plug m-r-5"></i> <span> {{ $t('integrations') }} </span></router-link>
                                </li>
                                <li v-if="member.is_admin && canAccess">
                                    <router-link :to="{ name: 'exchange-rate.index' }"><i class="fa-fw ti-money m-r-5"></i> {{ $t('exchange_rate') }}</router-link>
                                </li>
                                <li><a href="#" @click.prevent="doLogout"><i class="fa-fw ti-power-off m-r-5"></i> {{ $t('logout') }} </a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Right Sidebar -->
        <PmlUsersTracking :open="showSidebar" @close="closeUserTracking"></PmlUsersTracking>
    </div>
</template>

<script>
    import axios from 'axios'
    import client from 'utils/http'
    import PmlUsersTracking from './UsersTracking.vue'
    import PmlNotifications from './Notifications.vue'
    import { mapActions, mapGetters } from 'vuex'
    import { getAll } from 'services/deals'
    import _ from 'lodash'
    import bus from 'utils/events/bus'

    export default {
        data () {
            return {
                showSidebar: false,
                search: null,
                isSearching: false,
                dealOptions: []
            }
        },
        components: {PmlNotifications, PmlUsersTracking},
        computed: {
            ...mapGetters({
                member: 'getMember',
                tenant: 'getTenant'
            }),
            language () {
                return this.$i18n.locale === 'pt-BR' ? 'Português' : 'English'
            },
            flag () {
                return this.$i18n.locale === 'pt-BR' ? 'bra' : 'usa'
            },
            showTourBtn () {
                return this.$route.name === 'dashboard.first-deal'
            },
            canAccess () {
                return ['premium_power_sales'].includes(this.tenant.stripePlan)
            }
        },
        watch: {
            search (val) {
                if (this.search !== null) {
                    this.$router.push(`/deals/${val.id}`)
                    this.search = null
                }
            }
        },
        methods: {
            ...mapActions(['logout', 'toggleMainMenu']),
            asyncFind: _.debounce(function (query) {
                if (_.isEmpty(query)) return

                this.isSearching = true

                getAll({identity: query, orderBy: 'custom_status'})
                    .then(response => {
                        this.dealOptions = response.data
                        this.isSearching = false
                    })
            }, 500),
            customLabel (opt) {
                return `${opt.lead.full_name} – (${opt.lead.email})`
            },
            doLogout () {
                if (typeof this.$ma !== 'undefined') this.$ma.reset()
                this.logout()
                    .then(() => {
                        this.$router.push({name: 'auth.login'})
                    })
            },
            switchLanguage (lang) {
                window.localStorage.setItem('pml_lang', lang)
                axios.defaults.headers.common['Accept-Language'] = lang
                client.defaults.headers.common['Accept-Language'] = lang
                this.$i18n.locale = lang
            },
            closeUserTracking () {
                this.showSidebar = false
            },
            toggleMenu () {
                this.toggleMainMenu()
            },
            toggleSearch () {
                window.jQuery('.body_tag').toggleClass('search_active')
            },
            globalSearch () {
                this.$router.push({ name: 'deals.index', query: { search: this.search, orderBy: 'custom_status' } })
            },
            tour () {
                window.localStorage.setItem('pml_tour', true)
                if (this.$route.name === 'dashboard.first-deal')
                    bus.$emit('startTour')
                else
                    this.$router.push({name: 'dashboard.first-deal'})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/root/header/Main.vue